<template>
  <f7-page name="pzv-dyn" @page:init="onPageInit" @page:beforeout="onPageBeforeOut" @page:beforeremove="onPageBeforeRemove">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Kvalita podzemnej vody</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template>
      <f7-toolbar bottom>
        <f7-block class="pzv-toolbar">
          <f7-row>
            <f7-col style="padding:0 10px;">
              <f7-button class="pzv-search-btn" fill sheet-open=".pzv-search-sheet">Filter</f7-button>
            </f7-col>

          </f7-row>
        </f7-block>
      </f7-toolbar>

      <f7-sheet class="pzv-search-sheet"  style="height:75%;">
        <f7-toolbar>
          <div class="left ml-1 font-weight-bold">Filter</div>
          <div class="right">
            <f7-link sheet-close>Zavrieť</f7-link>
          </div>
        </f7-toolbar>
        <!-- Scrollable sheet content -->
        <f7-page-content>
          <f7-list inline-labels no-hairlines-md class="no-margin-top">
            <template v-if="notEmptyObject(ciselnikyData)">

              <f7-list-input
                  label="Rok"
                  type="select"
                  :value="selectedYear"
                  @change="selectedYear = $event.target.value">
                <option v-for="(s_rok, index) in dostupneRoky" :key="s_rok" :value="s_rok">{{ s_rok }}</option>
              </f7-list-input>

              <f7-list-input
                  label="Ukazovateľ"
                  type="select"
                  :value="selectedUkazovatel"
                  @change="selectedUkazovatel = $event.target.value">
                <option value :selected="selectedUkazovatel === ''"></option>
                <option v-for="(ukazovatel, index) in ukazovatele" :key="ukazovatel.kod" :value="ukazovatel.kod">{{ ukazovatel.nazov }}</option>
              </f7-list-input>

              <f7-list-input
                  label="Skupina ukazovateľov"
                  type="select"
                  :value="selectedSkupina"
                  @change="selectedSkupina = $event.target.value">
                <option value :selected="selectedSkupina === ''"></option>
                <option value="-1" :selected="selectedSkupina === -1">-- všetky --</option>
                <option v-for="(skupina_item, index) in skupiny_ukazovatelov" :key="skupina_item.id" :value="skupina_item.id">{{ skupina_item.nazov }}</option>
              </f7-list-input>


              <f7-list-input
                  label="Okres"
                  type="select"
                  :value="selectedOkres"
                  @change="selectedOkres = $event.target.value">
                <option value :selected="selectedPovodie === null">-- všetky --</option>
                <option v-for="(okres, index) in okresy" :key="okres.id" :value="okres.id">{{ okres.nazov }}</option>
              </f7-list-input>

              <f7-list-input
                  label="CHVO"
                  type="select"
                  :value="selectedCHVO"
                  @change="selectedCHVO = $event.target.value">
                <option value :selected="selectedPovodie === null">-- všetky --</option>
                <option v-for="(chvo_item, index) in chvo" :key="chvo_item.id" :value="chvo_item.id">{{ chvo_item.nazov }}</option>
              </f7-list-input>

              <f7-list-input
                  label="Povodie"
                  type="select"
                  :value="selectedPovodie"
                  @change="selectedPovodie = $event.target.value">
                <option value :selected="selectedPovodie === null">-- všetky --</option>
                <option v-for="(povodie_item, index) in povodia" :key="povodie_item.id" :value="povodie_item.id">{{ povodie_item.nazov }}</option>
              </f7-list-input>
              <!-- -->
              <f7-list-input
                  label="Typ objektu"
                  type="select"
                  :value="selectedTyp"
                  @change="selectedTyp = $event.target.value">
                <option value :selected="selectedTyp === null">-- všetky --</option>
                <option v-for="(typ_objektu_item, index) in typy_objektov" :key="typ_objektu_item.id" :value="typ_objektu_item.id">{{ typ_objektu_item.nazov | capitalize }}</option>
              </f7-list-input>

              <f7-list-input
                  label="Typ monitorovania"
                  type="select"
                  :value="selectedMonitoring"
                  @change="selectedMonitoring = $event.target.value">
                <option value :selected="selectedMonitoring === null">-- všetky --</option>
                <option v-for="(typ_monitoringu_item, index) in typy_monitoringu" :key="typ_monitoringu_item.id" :value="typ_monitoringu_item.id">{{ typ_monitoringu_item.nazov }}</option>
              </f7-list-input>


              <f7-list-input
                  label="Útvar PZV"
                  type="select"
                  :value="selectedUtvar"
                  @change="selectedUtvar = $event.target.value">
                <option value :selected="selectedUtvar === null">-- všetky --</option>
                <option v-for="(utvar_item, index) in utvary" :key="utvar_item" :value="utvar_item">{{ utvar_item }}</option>
              </f7-list-input>


            </template>
            <f7-list-item title="Zobraziť rieky" class="pzv-ch-item">
              <f7-toggle slot="after"
                         :checked="ch_rieky"
                         @change="ch_rieky = $event.target.checked"
              ></f7-toggle>
            </f7-list-item>
            <f7-list-item title="Zobraziť CHVO" class="pzv-ch-item">
              <f7-toggle slot="after"
                         :checked="ch_chvo"
                         @change="ch_chvo = $event.target.checked"
              ></f7-toggle>
            </f7-list-item>
            <f7-list-item title="Zobraziť povodia" class="pzv-ch-item">
              <f7-toggle slot="after"
                         :checked="ch_povodia"
                         @change="ch_povodia = $event.target.checked"
              ></f7-toggle>
            </f7-list-item>
            <f7-list-item title="Zobraziť útvary" class="pzv-ch-item">
              <f7-toggle slot="after"
                         :checked="ch_utvary"
                         @change="ch_utvary = $event.target.checked"
              ></f7-toggle>
            </f7-list-item>
          </f7-list>

        </f7-page-content>
      </f7-sheet>

      <template v-if="isStaniceLoaded">

        <f7-popup class="pzv-select-place-popup">
          <f7-page class="page-with-subnavbar">
            <f7-navbar title="Vyberte objekt">
              <f7-subnavbar :inner="false">
                <f7-searchbar
                    class="pzv-searchbar"
                    search-container=".virtual-list"
                    search-item="li"
                    search-in=".item-title"
                    placeholder="Hľadať..."
                    :disable-button="!$theme.aurora"
                    :remove-diacritics="true"
                ></f7-searchbar>
              </f7-subnavbar>

              <f7-nav-right>
                <f7-link popup-close>Návrat</f7-link>
              </f7-nav-right>
            </f7-navbar>
            <f7-list class="searchbar-not-found">
              <f7-list-item title="Objekt nebol nájdený..."></f7-list-item>
            </f7-list>
            <f7-list
                class="searchbar-found no-margin-top"
                virtual-list
                :virtual-list-params="{ items, searchAll, renderExternal }"

            >
              <ul>
                <f7-list-item
                    v-for="(item, index) in vlData.items"
                    :key="index"
                    @click="selectObject(item)"
                    :title="item.nazov_objektu + ` (` + item.cislo_objektu + `)`"
                    :style="`top: ${vlData.topPosition}px`"
                >
                  <f7-badge v-if="selected_cislo_objektu === item.cislo_objektu" color="blue">✓</f7-badge>
                </f7-list-item>
              </ul>
            </f7-list>

          </f7-page>
        </f7-popup>
      </template>

      <l-map :zoom="zoom"
             :center="center"
             :options="mapOptions"
             ref="pzvDynMap"
             class="pzv-dyn-map"
             @ready="mapReady()"
      >
        <l-control-zoom position="bottomright"  ></l-control-zoom>
        <l-tile-layer
            ref="layerBg"
            :url="url"
            :attribution="attribution"
        />
        <l-tile-layer
            :url="borderUrl"
        />
        <l-tile-layer
            ref="riekyLayer"
            name="Riečna sieť"
            :url="riversUrl"
            :visible="ch_rieky"
            :opacity="0.5" />
        <l-geo-json
            ref="povodiaGeoJsonLayer"
            :geojson="povodiaGeoJsonData"
            :options-style="povodiaStyleFunction"
            :options="povodiaGeoJsonOptions"
            :visible="ch_povodia"
        />
        <l-geo-json
            ref="utvaryGeoJsonLayer"
            :geojson="utvaryGeoJsonData"
            :options-style="utvaryStyleFunction"
            :options="utvaryGeoJsonOptions"
            :visible="ch_utvary"
        />
        <l-geo-json
            ref="chvoGeoJsonLayer"
            :geojson="chvoGeoJsonData"
            :options-style="chvoStyleFunction"
            :options="chvoGeoJsonOptions"
            :visible="ch_chvo"
        />
        <l-geo-json
            ref="objektyGeoJsonLayer"
            :geojson="pzvdynGeoJsonData"
            :options="geoJsonOptions"
        />

        <l-control
            :position="'bottomleft'"
        >

          <f7-button :disabled="!isStaniceLoaded" class="text-color-white" fill popup-open=".pzv-select-place-popup" icon-f7="search"></f7-button>

        </l-control>

        <l-control v-if="isGeolocationEnabled" :position="'bottomright'">
          <div class="leaflet-bar">
            <a @click="geoLocateMap" role="button"><i class="icon f7-icons" style="font-size: 22px;">placemark_fill</i></a>
          </div>
        </l-control>

        <l-control v-if="isGeolocationEnabled && extraParams.clearBtnVar" :position="'bottomright'">
          <div class="leaflet-bar">
            <a @click="clearMarker" role="button"><i class="icon f7-icons" style="font-size: 22px;">xmark</i></a>
          </div>
        </l-control>


      </l-map>


    </template>

  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LImageOverlay, LMarker, LGeoJson, LControl, LControlZoom } from 'vue2-leaflet';
import { LSvgShapeMarker} from "leaflet-svg-shape-markers";
import 'leaflet/dist/leaflet.css';
import chvoGeoJsonMap from '../static/shmu/maps/CHVO.json';
import utvaryGeoJsonMap from '../static/shmu/maps/Utvary_PzV.json';
import povodiaGeoJsonMap from '../static/shmu/maps/ciastkove_povodia.json';
import shmuMixin from "../js/mixin";
import geoLocationMixin from "../js/geoLocationMixin";


var progressDialog, loadingDialog;
var svt_icn_markers = [];

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LGeoJson,
    LControlZoom,
    LSvgShapeMarker,
    LControl,
  },
  mixins: [
    shmuMixin,
    geoLocationMixin
  ],
  data: function () {
    return {
      ciselnikyData: {},
      isCiselnikyLoaded: false,
      objektData: {},
      isObjektLoaded: false,
      staniceData: [],
      isStaniceLoaded: false,
      overlimitsData: [],
      isOverLimitsLoaded: false,

      isError: false,
      errorMsg: null,
      isDataLoaded: false,
      isLoading: false,
      isLoadingCter: 0,
      isLoadingSub: false,
      minYear: null,
      maxYear: null,
      selectedYear: "",
      selectedOkres: "",
      selectedCHVO: "",
      selectedObjekt: "",
      selectedTyp: "",
      selectedMonitoring: "",
      selectedUkazovatel: "",
      selectedSkupina: "",
      selectedUtvar: "",
      selectedPovodie: "",
      selected_cislo_objektu: null,
      ch_chvo: false,
      ch_utvary: false,
      ch_povodia: false,
      ch_rieky: true,
      choosenObjekt: null,

      mapOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        maxBounds: [[51.7, 25.79], [45.05, 10.6]],
        minZoom: 6,
        maxZoom: 12
      },

      items: [],
      mapObject: {},
      vlData: {
        items: [],
      },

      pzvdynGeoJsonData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      chvoGeoJsonData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      utvaryGeoJsonData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      povodiaGeoJsonData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      zoom: 7.5,
      center: latLng(48.688714, 19.696843),
      url: SHMUconf.MAP_TILE_URL + 'data/datatiles/osm/v1/{z}/{x}/{y}.png',
      borderUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/hranice_sk/v1/{z}/{x}/{y}.png',
      riversUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/rieky/v2/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright" class="external">OpenStreetMap</a> contributors',
      baseUrl: SHMUconf.SHMU_CORE_URL,

      // geolocation
      extraParams: {
        circleMarkerObject: null,
        pointMarkerObject: null,
        clearBtnVar: false
      },

    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  watch: {
    isLoadingCter(v, prev_v) {
      if (v <= 0) {
        if (loadingDialog !== null) {
          loadingDialog.close();
          loadingDialog = null;
        }
        this.isLoadingCter = 0;
      } else if (v === 1) {
        loadingDialog = this.$f7.dialog.preloader('Načítavam...');
      } else {
        // nerobime nic
      }
    },
    selectedYear(v) {
      this.overlimitsData = [];
      this.getStations(v);
    },
    selectedObjekt(v) {
      if (v) {
        this.selectedOkres = "";
        this.$refs.pzvDynMap.mapObject.flyTo([v.gps_lat, v.gps_lon], 12, { animate:false });
        this.choosenObjekt = v.cislo_objektu;
      } else {
        // this.$refs.pzvDynMap.mapObject.flyTo(this.center, this.zoom);
      }
    },
    selectedOkres(v) {
      if (v) {
        let zoznam_objektov = this.staniceData.filter(item => item.okres && parseInt(item.okres.id) === parseInt(v));
        let centered_latlon = this.averageGeolocation(zoznam_objektov);
        if (centered_latlon) {
          this.$refs.pzvDynMap.mapObject.flyTo([centered_latlon.gps_lat, centered_latlon.gps_lon], 9, {animate: true});
        }
      } else {
        // reset zoom
        this.$refs.pzvDynMap.mapObject.flyTo(this.center, this.zoom);
      }
    },
    selectedCHVO(v) {
      if (v) {
        let zoznam_objektov = this.staniceData.filter(item => item.chvo && parseInt(item.chvo.id) === parseInt(v));
        let centered_latlon = this.averageGeolocation(zoznam_objektov);
        if (centered_latlon) {
          this.ch_chvo = true;
          this.$refs.pzvDynMap.mapObject.flyTo([centered_latlon.gps_lat, centered_latlon.gps_lon], 9, {animate: true});
        }
      } else {
        // reset zoom
        this.$refs.pzvDynMap.mapObject.flyTo(this.center, this.zoom);
        this.ch_chvo = false;
      }
    },
    selectedUtvar(v) {
      if (v) {
        let zoznam_objektov = this.staniceData.filter(item => item.utvar && item.utvar === v);
        let centered_latlon = this.averageGeolocation(zoznam_objektov);
        if (centered_latlon) {
          this.ch_utvary = true;
          this.$refs.pzvDynMap.mapObject.flyTo([centered_latlon.gps_lat, centered_latlon.gps_lon], 9, {animate: true});
        }
      } else {
        // reset zoom
        this.$refs.pzvDynMap.mapObject.flyTo(this.center, this.zoom);
        this.ch_utvary = false;
      }
    },
    selectedPovodie(v) {
      if (v) {
        let zoznam_objektov = this.staniceData.filter(item => item.povodie && parseInt(item.povodie.id) === parseInt(v));
        let centered_latlon = this.averageGeolocation(zoznam_objektov);
        if (centered_latlon) {
          this.ch_povodia = true;
          this.$refs.pzvDynMap.mapObject.flyTo([centered_latlon.gps_lat, centered_latlon.gps_lon], 8, {animate: true});
        }
      } else {
        // reset zoom
        this.$refs.pzvDynMap.mapObject.flyTo(this.center, this.zoom);
        this.ch_povodia = false;
      }
    },
    selectedSkupina(v) {
      if (v) {
        this.selectedUkazovatel = "";
        this.getOverLimits(this.selectedYear, v, 0);
      } else {
        this.overlimitsData = [];
      }
    },
    selectedUkazovatel(v) {
      if (v) {
        this.selectedSkupina = "";
        this.getOverLimits(this.selectedYear, 0, v);
      } else {
        this.overlimitsData = [];
      }
    },
    pzvdynGeoJsonData(v) {
      const self = this;
      // aj sa zmenili geojsodata (znovu sa nacitali), overime ci mame vybranu skupinu alebo ukazovatel a musime reloadnut data pre aktualny rok
      if (this.selectedSkupina) {
        this.selectedUkazovatel = null;
        this.getOverLimits(this.selectedYear, this.selectedSkupina, 0);
      }
      if (this.selectedUkazovatel) {
        this.selectedSkupina = "";
        this.getOverLimits(this.selectedYear, 0, this.selectedUkazovatel);
      }

      if (svt_icn_markers.length > 0 && this.mapObject) {
        svt_icn_markers.forEach(marker => {
          self.mapObject.removeLayer(marker);
        });
        svt_icn_markers = [];
      }

    },
    filterChanged: {
      handler: function(val) {
        // console.log('filter zmeneny...', val);
        this.selectedObjekt = "";
        this.choosenObjekt = null;
      },
      deep: true
    },
    staniceData() {
      this.items = this.stanice;
    }

  },
  computed: {
    filterChanged() {
      const { selectedOkres, selectedCHVO, selectedPovodie, selectedTyp, selectedMonitoring, selectedUtvar } = this;
      return { selectedOkres, selectedCHVO, selectedPovodie, selectedTyp, selectedMonitoring, selectedUtvar };

    },
    geoJsonOptions() {
      // ked sa zmeni nieco z tychto parametrov tak spravi fire geoJsonOptions a tym sa vyvola refresh pointov
      const okres = this.selectedOkres;
      const chvo = this.selectedCHVO;
      const typ_objektu = this.selectedTyp;
      const typ_monitoring = this.selectedMonitoring;
      const utvar = this.selectedUtvar;
      // const skupina = this.selectedSkupina;
      // const ukazovatel = this.selectedUkazovatel;
      const povodie = this.selectedPovodie;
      const overlimit_data = this.overlimitsData;
      const m_ch_chvo = this.ch_chvo;
      const m_ch_povodia = this.ch_povodia;
      const m_ch_utvary = this.ch_utvary;
      return {
        onEachFeature: this.onEachFeatureFunction,
        pointToLayer: this.makePzvPoint,
      };
    },
    chvoGeoJsonOptions() {
      return {
        onEachFeature: this.onEachFeatureFunctionCHVO
      };
    },
    onEachFeatureFunctionCHVO() {
      /*
      return (feature, layer) => {
        layer.bindTooltip(feature.properties.CHVO);
      }
      */
    },
    chvoStyleFunction() {
      const self = this;
      const m_selectedCHVO = self.selectedCHVO;
      return (feature) => {

        if (m_selectedCHVO !== "") {
          if (parseInt(m_selectedCHVO) != parseInt(feature.properties.DB_ID)) {
            return {
              weight: 0,
              opacity:0,
              fillColor: 'rgba(43,155,0,0)'
            }
          }
        }

        let curfillColor = 'rgb(43,155,0,0.3)';
        return {
          fillColor: curfillColor ,
          weight: 1,
          opacity: 0.8,
          color: 'rgb(43,155,0)',
          fillOpacity: 0.8
        }
      };
    },

    povodiaGeoJsonOptions() {
      return {
        onEachFeature: this.onEachFeatureFunctionPovodia
      };
    },
    onEachFeatureFunctionPovodia() {
      /*
      return (feature, layer) => {
        layer.bindTooltip('Povodie: ' + feature.properties.NAZOV_POV);
      }

       */
    },
    povodiaStyleFunction() {
      const self = this;
      const m_selectedPovodie = self.selectedPovodie;

      return (feature) => {

        if (m_selectedPovodie !== "") {
          if (parseInt(m_selectedPovodie) != parseInt(feature.properties.DB_ID)) {
            return {
              weight: 0,
              opacity:0,
              fillColor: 'rgba(43,155,0,0)'
            }
          }
        }

        let curfillColor = 'rgba(0,149,255, 0)';
        return {
          fillColor: curfillColor ,
          weight: 2,
          opacity: 1,
          color: 'rgb(0,149,255)',
          fillOpacity: 0.8
        }
      };
    },

    utvaryGeoJsonOptions() {
      return {
        onEachFeature: this.onEachFeatureFunctionUtvary
      };
    },
    onEachFeatureFunctionUtvary() {
      /*
      return (feature, layer) => {
        layer.bindTooltip(feature.properties.KOD_UTV + ' - ' + feature.properties.NAZ_UTV);
      }
       */
    },
    utvaryStyleFunction() {
      const self = this;
      const m_selectedUtvar = self.selectedUtvar;

      return (feature) => {

        let curfillColor = 'rgba(227,136,58, 0.3)';
        if (feature.properties.HORIZONT == 2) {
          curfillColor = 'rgba(227,136,58, 0)'
        }

        if (m_selectedUtvar !== "") {
          if (m_selectedUtvar != feature.properties.KOD_UTV) {
            return {
              weight: 0,
              opacity:0,
              fillColor: 'rgba(227,136,58, 0)'
            }
          }
        }

        return {
          fillColor: curfillColor ,
          weight: 1,
          opacity: 0.8,
          color: 'rgb(128,0,0)',
          fillOpacity: 0.8
        }
      };
    },

    choosenObjektDetail() {
      const chobj = this.choosenObjekt;
      if (chobj) {
        return this.staniceData.find(item => parseInt(item.cislo_objektu) === chobj);
      }
    },

    // basics
    dostupneRoky() {
      const i_ciselnikyData = this.ciselnikyData;
      this.selectedYear = i_ciselnikyData.dostupne_roky[0];
      return i_ciselnikyData.dostupne_roky;
    },
    typyObjektov() {
      const i_ciselnikyData = this.ciselnikyData;
      return i_ciselnikyData.typy_objektov;
    },
    povodia() {
      const i_ciselnikyData = this.ciselnikyData;
      return i_ciselnikyData.povodia;
    },
    okresy() {
      const i_ciselnikyData = this.ciselnikyData;
      return i_ciselnikyData.okresy;
    },
    chvo() {
      const i_ciselnikyData = this.ciselnikyData;
      return i_ciselnikyData.chvo;
    },
    typy_objektov() {
      const i_ciselnikyData = this.ciselnikyData;
      return i_ciselnikyData.typy_objektov;
    },
    typy_monitoringu() {
      const i_ciselnikyData = this.ciselnikyData;
      return i_ciselnikyData.monitoring;
    },
    utvary() {
      const i_ciselnikyData = this.ciselnikyData;
      return i_ciselnikyData.utvary;
    },
    skupiny_ukazovatelov() {
      const i_ciselnikyData = this.ciselnikyData;
      return i_ciselnikyData.skupiny_ukazovatelov;
    },
    ukazovatele() {
      const i_ukazovateleData = this.ciselnikyData.ukazovatele;
      i_ukazovateleData.sort((a,b) => (a.nazov > b.nazov) ? 1 : ((b.nazov > a.nazov) ? -1 : 0));
      i_ukazovateleData.unshift({nazov: '-- Všetky --', kod: '-1' });
      return i_ukazovateleData;
    },
    stanice() {
      const i_staniceData = this.staniceData;
      i_staniceData.sort((a,b) => (a.nazov_objektu > b.nazov_objektu) ? 1 : ((b.nazov_objektu > a.nazov_objektu) ? -1 : 0));
      return i_staniceData;
    },
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-vodne-zdroje');
    this.$f7.accordion.open('.shmu-i-vodne-zdroje');
    this.$nextTick(() => {
      this.initMap();
    });


  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      this.chvoGeoJsonData = chvoGeoJsonMap;
      this.utvaryGeoJsonData = utvaryGeoJsonMap;
      this.povodiaGeoJsonData = povodiaGeoJsonMap;


      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh


        this.getCiselniky();


      }


    },
    mapReady() {
      this.mapObject = this.$refs.pzvDynMap.mapObject
    },
    initMap() {
      const self = this;
      //this.$refs.map.mapObject.ANY_LEAFLET_MAP_METHOD();
      this.$$('.leaflet-control-attribution a').each((i, item) => {
        self.$$(item).addClass('external')
      });

      this.$refs.pzvDynMap.mapObject.on('zoomend', function (e) {
        if (this.getZoom() > 9) {
          document.querySelectorAll(".i-label").forEach( function(el) { el.style.display = "block" });
        } else {
          document.querySelectorAll(".i-label").forEach( function(el) { el.style.display = "none" });
        }
      });

      // geolocation
      this.locationMapInitEvents(this, this.$refs.pzvDynMap.mapObject);


      // console.log('leafLet init done...')

    },
    getStations(rok) {
      const self = this;

      self.isLoadingCter++;

      Axios.get(SHMUconf.API_BASE_URL + 'pzvdyn/getstations?rok=' + rok, {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.staniceData = response.data;
          self.isStaniceLoaded = true;

          // self.object_items = self.stanice;

          this.getPzvDynGeoJSONData(rok);

        } else {
          if (response.data.error[0].text) {
            self.$f7.dialog.alert( response.data.error[0].text, 'Nastala chyba');
          } else {
            self.$f7.dialog.alert('Nastala chyba pri načítavaní údajov!', 'Nastala chyba');
          }
        }

        self.isLoadingCter--;


      }).catch((error) => {
        self.isLoadingCter--;
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
      });

    },
    getPzvDynGeoJSONData(rok) {
      const self = this;

      self.isLoadingCter++;
      Axios.get(SHMUconf.API_BASE_URL + 'pzvdyn/getgeojson?rok=' + rok, {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.pzvdynGeoJsonData = response.data;

          this.$nextTick(() => {
            this.initMap();
          });

        } else {
          if (response.data.error[0].text) {
            self.$f7.dialog.alert( response.data.error[0].text, 'Nastala chyba');
          } else {
            self.$f7.dialog.alert('Nastala chyba pri načítavaní údajov!', 'Nastala chyba');
          }
        }
        self.isLoadingCter--;

      }).catch((error) => {
        self.isLoadingCter--;
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
      });
    },
    getCiselniky() {
      const self = this;

      let c = this.$ls.get('pzv_dyn_ciselniky');
      if (c) {
        this.ciselnikyData = c;
        this.isCiselnikyLoaded = true;
        return;
      }

      this.isLoadingCter++;

      Axios.get(SHMUconf.API_BASE_URL + 'pzvdyn/getciselniky', {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {
            if (!response.data.error) {
              self.ciselnikyData = response.data;
              self.isCiselnikyLoaded = true;
              self.$ls.set('pzv_dyn_ciselniky', self.ciselnikyData, 7 * 24 * 60 * 60 * 1000); //  1 den
            } else {
              self.$f7.dialog.alert('Nepodarilo sa načítať číselníky ku kvalite podzemnej vody', 'Nastala chyba');
            }

            self.isLoadingCter--;

          }).catch((error) => {
        self.isLoadingCter--;
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
      });


    },
    getOverLimits(rok, skupina_id, ukazovatel_kod) {
      const self = this;
      if (skupina_id === "-1") skupina_id = "0";
      if (ukazovatel_kod === "-1") ukazovatel_kod = "0";

      this.isLoadingCter++;

      Axios.get(SHMUconf.API_BASE_URL + 'pzvdyn/getoverlimitstations?rok='+rok+'&skupina_ukazovatel_id=' + skupina_id +'&kod_ukazovatela=' + ukazovatel_kod, {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.overlimitsData = response.data;
          self.isOverLimitsLoaded = true;

        } else {
          if (response.data.error[0].text) {
            self.$f7.dialog.alert( response.data.error[0].text, 'Nastala chyba');
          } else {
            self.$f7.dialog.alert('Nastala chyba pri načítavaní údajov!', 'Nastala chyba');
          }
        }
        self.isLoadingCter--;
      }).catch((error) => {
        self.isLoadingCter--;
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
      });

    },


    makePzvPoint(feature, latlng) {
      const self = this;
      let props = feature.properties;
      let width = 1;
      let radius = 5;
      let defaultFillColor = 'rgb(200,200,200 ,1)';
      let overlimitFillColor = 'rgba(195,8,8, 1)';
      let underlimitFillColor = 'rgba(74,142,3, 1)';
      let point;

      let fillColor = defaultFillColor;

      if (this.selectedOkres !== "") {
        if (parseInt(props.prop_okres) !== parseInt(this.selectedOkres)) {
          if (feature.id in svt_icn_markers) {
            self.mapObject.removeLayer(svt_icn_markers[feature.id]);
            delete svt_icn_markers[feature.id];
          }
          return;
        }
      }

      if (this.selectedCHVO !== "") {
        if (parseInt(props.prop_chvo) !== parseInt(this.selectedCHVO)) {
          if (feature.id in svt_icn_markers) {
            self.mapObject.removeLayer(svt_icn_markers[feature.id]);
            delete svt_icn_markers[feature.id];
          }
          return;
        }
      }

      if (this.selectedTyp !== "") {
        if (parseInt(props.prop_typ) !== parseInt(this.selectedTyp)) {
          if (feature.id in svt_icn_markers) {
            self.mapObject.removeLayer(svt_icn_markers[feature.id]);
            delete svt_icn_markers[feature.id];
          }
          return;
        }
      }

      if (this.selectedMonitoring !== "") {
        if (parseInt(props.prop_monitoring) !== parseInt(this.selectedMonitoring)) {
          if (feature.id in svt_icn_markers) {
            self.mapObject.removeLayer(svt_icn_markers[feature.id]);
            delete svt_icn_markers[feature.id];
          }
          return;
        }
      }

      if (this.selectedUtvar !== "") {
        if (props.prop_utvar !== this.selectedUtvar) {
          if (feature.id in svt_icn_markers) {
            self.mapObject.removeLayer(svt_icn_markers[feature.id]);
            delete svt_icn_markers[feature.id];
          }
          return;
        }
      }

      if (this.selectedPovodie !== "") {
        if (parseInt(props.prop_povodie) !== parseInt(this.selectedPovodie)) {
          if (feature.id in svt_icn_markers) {
            self.mapObject.removeLayer(svt_icn_markers[feature.id]);
            delete svt_icn_markers[feature.id];
          }
          return;
        }
      }

      if (this.overlimitsData.length > 0) {
        let res = this.overlimitsData.find(item => parseInt(item.cislo_objektu) === parseInt(feature.id));
        if (res) {
          if (res.overlimit === 0) {
            fillColor = underlimitFillColor;
          } else {
            fillColor = overlimitFillColor;
          }
        } else {
          fillColor = defaultFillColor;
        }
      }



      if (parseInt(props.prop_typ) === 1) {
        point = L.circleMarker(latlng, {
          radius: radius,
          fillColor: fillColor,
          color: "#000",
          weight: width,
          opacity: 1,
          fillOpacity: 0.9,
        });

      } else {
        point = L.shapeMarker(latlng, {
          shape: "square",
          radius: radius,
          fillColor: fillColor,
          color: "#000",
          weight: width,
          opacity: 1,
          fillOpacity: 0.9,
        });
      }

      point.bindTooltip(props.prop_name + ' (' + feature.id + ')', { direction:'top', offset: [0, -5] });


      let myIcon = L.divIcon({className: 'i-label', html:feature.id, iconAnchor:[20,25]});
      if (feature.id in svt_icn_markers) {
        // ak je uz v poli tak ignorujeme
      } else {
        svt_icn_markers[feature.id] = L.marker(latlng, {icon: myIcon}).addTo(this.mapObject);
        svt_icn_markers[feature.id]._icon.id = feature.id;

        if (this.mapObject.getZoom() > 9) {
          svt_icn_markers[feature.id]._icon.style.display = "block";
        } else {
          svt_icn_markers[feature.id]._icon.style.display = "none";
        }

        svt_icn_markers[feature.id].on({
          click: function (e) {
            let cislo_objektu = e.target._icon.id;
            if (cislo_objektu && parseInt(cislo_objektu) > 0) {
              self.choosenObjekt = parseInt(cislo_objektu);
              self.selectedObjekt = "";
            }
          }
        });
      }




      return point;
    },
    onEachFeatureFunction(feature, layer) {

      const self = this;
      layer.on({
        click: function (v) {
          let cislo_objektu = v.target.feature.id;
          if (cislo_objektu && parseInt(cislo_objektu) > 0) {
            self.choosenObjekt = cislo_objektu;
            let item = {
              cislo_objektu: self.choosenObjekt
            }
            self.selectedObjekt = "";
            self.selectObject(item);
          }
        }
      });

    },
    averageGeolocation(points) {
      if (points.length === 0) {
        return false;
      }
      if (points.length === 1) {
        return points[0];
      }

      let x = 0.0;
      let y = 0.0;
      let z = 0.0;


      for (let coord of points) {
        let latitude = coord.gps_lat * Math.PI / 180;
        let longitude = coord.gps_lon * Math.PI / 180;

        x += Math.cos(latitude) * Math.cos(longitude);
        y += Math.cos(latitude) * Math.sin(longitude);
        z += Math.sin(latitude);
      }

      let total = points.length;

      x = x / total;
      y = y / total;
      z = z / total;

      let centralLongitude = Math.atan2(y, x);
      let centralSquareRoot = Math.sqrt(x * x + y * y);
      let centralLatitude = Math.atan2(z, centralSquareRoot);


      return {
        gps_lat: centralLatitude * 180 / Math.PI,
        gps_lon: centralLongitude * 180 / Math.PI
      };
    },
    /*
    customSelectFilter(option, label, search) {
      return (label + '|'+ this.$removeDiacritics(label)).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
     */

    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) > 3 * 60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    onPageBeforeOut() {
      const self = this;
      // console.log('onPageBeforeOut');
      // Close opened sheets on page out
      self.$f7.sheet.close();
    },
    onPageBeforeRemove() {
      const self = this;
      // console.log('onPageBeforeRemove');
      // Destroy sheet modal when page removed
      if (self.sheet) self.sheet.destroy();
    },

    searchAll(query, items) {
      const found = [];
      for (let i = 0; i < items.length; i += 1) {
        if (items[i].nazov_objektu.toLowerCase().indexOf(query.toLowerCase()) === 0 || query.trim() === '') found.push(i);
      }
      return found; // return array with mathced indexes
    },
    renderExternal(vl, vlData) {
      this.vlData = vlData;
    },
    onPopupOpen(e) {
      //console.log(this.$f7.searchbar.get('.nwp-searchbar'));
      //this.$f7.initSearchbar('.nwp-searchbar');
    },
    selectObject(item) {
      this.$f7.popup.get('.pzv-select-place-popup').close();
      this.$f7router.navigate('/kvalita-podzemnej-vody/detail/'+this.selectedYear+'/'+item.cislo_objektu+'/' + this.selectedSkupina);

    },

    // geolocation
    geoLocateMap() {
      this.locationLocate(this, this.$refs.pzvDynMap.mapObject, 10);
    },
    clearMarker() {
      this.locationClearMarker(this, this.$refs.pzvDynMap.mapObject);
    },
    onLocationFound(e) {
      this.locationFound(this, this.$refs.pzvDynMap.mapObject, e);
    },
    onLocationError(e) {
      this.locationError(this, e);
    }

  }



}
</script>

<style lang="scss">

.pzv-toolbar {
  max-width:400px;
  width:100%;
  margin: 0px auto;
}


</style>
